import { useGenericQuery } from '../../../core/api/reactQuery';
import { getMyCourses } from "../../../core/queries/course";
import { useCoursesStore } from "../stores/courseStore";


export function useMyRegularCourses() {
    const {setMyCourses} = useCoursesStore();

    const {
        data,
        isError,
        error,
        isSuccess,
        isPending
    } = useGenericQuery(['myCourses'], () => getMyCourses(), setMyCourses);


    return {
        data,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
    }
}
